import { render, staticRenderFns } from "./Consumables.vue?vue&type=template&id=b619d03c&scoped=true"
import script from "./Consumables.vue?vue&type=script&lang=js"
export * from "./Consumables.vue?vue&type=script&lang=js"
import style0 from "./Consumables.vue?vue&type=style&index=0&id=b619d03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b619d03c",
  null
  
)

export default component.exports